module.exports = __webpack_public_path__ + "img/icon3.a5d8e5ea.png";